import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
import { MarketplaceService } from 'src/app/services/marketplace/marketplace';
import { ModalService } from '../modal.service';
import { CoreTranslateService } from 'src/app/services/utilitys/utilitys.service';

@Component({
  selector: 'app-modal-market-store-edit',
  templateUrl: './modal-market-store-edit.component.html',
  styleUrls: ['./modal-market-store-edit.component.scss']
})
export class ModalMarketStoreEditComponent implements OnInit {

  @ViewChild('marketStoreEditModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  store: any = {};
  categorys: any = [];
  imageUrl: any;
  customStoreModel: any = {};
  callback: Function;
  errorMsg = '';
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService,
    private mkp: MarketplaceService,
    private ngxLoading: NgxUiLoaderService,
    private coreTranslate: CoreTranslateService
  ) { }

  ngOnInit() {
    this.modalServ.onMarketStoreEdit.subscribe((req: any) => {
      this.errorMsg = '';
      this.getMyStore(req.id);
      this.callback = req.callback;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onMarketStoreEditHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  async getMyStore(id: any) {
    this.store = await this.mkp.getMerchantInfo(id);
    this.imageUrl = this.store.ImageUrl;
    this.getMarketPlaceCategory();
  }

  getMarketPlaceCategory() {
    this.api.getMarketPlaceCategory(true).subscribe(res => {
      if (res.Code == 200) {
        this.categorys = res.Results;
      }  else {
        console.error(res);
      }
    }, err => {
      console.error(err);
    });
  }

  fileChangeEvent(event: any) {
    // this.hide();
    this.modalServ.onImageCapture.emit({image: event, callback: (res)=>{
      // console.log(res);
      if(res) {
        this.imageUrl = res;
      }
      
      // this.modalRef = this.modalService.show(this.modal, this.configmodal);
    }});
  }

  confirmEditStore() {
    if (!this.validation()) return;
    this.ngxLoading.start();
    this.api.marketPlaceMerchantUpdate(this.customStoreModel).subscribe(res => {
      if (res.Code == 200) {
        this.callback({status: 'success'});
      } else {
        this.callback({status: 'fail'});
      }
      this.hide();
      this.ngxLoading.stopAll();
    }, err => {
      this.hide();
      this.ngxLoading.stopAll();
      console.error(err);
      this.callback({status: 'fail'});
    });
  }

  validation() {
    var model = this.store;
    this.customStoreModel.merch_name = model.MerchantName;
    this.customStoreModel.merch_cat = model.CategoryId;
    this.customStoreModel.phone_number = model.PhoneNumber;
    this.customStoreModel.line_id = model.Line;
    this.customStoreModel.ig = model.IG;
    this.customStoreModel.facebook = model.Facebook;
    this.customStoreModel.description = model.MerchantDescription;
    this.customStoreModel.merchant_id = model.MerchantId;
    if(this.imageUrl == this.store.ImageUrl) {
      this.customStoreModel.imageStore = null;
    } else {
      this.customStoreModel.imageStore = this.imageUrl;
    }
    
    if (Object.keys(this.customStoreModel).length === 0) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_FILL_ALL_INFORMATION');
      return false;
    } else if (!this.customStoreModel.merch_name) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_STORE_NAME');
      return false;
    } else if (!this.customStoreModel.phone_number) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PHONE_NUMBER');
      return false;
    } 
    // else if (!this.customStoreModel.merch_cat) {
    //   this.errorMsg = 'กรุณาระบุประเภทสินค้า';
    //   return false;
    // }

    return true;
  }

}
